import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {deactivateNotificationMessage, getNotificationMessages} from 'services/login.service'

export interface Inotification {
    isLoading: boolean
    error: any
    response: any
    deactivateResponse: any
}

const initialState: Inotification = {
    isLoading: false,
    error: null,
    response: [],
    deactivateResponse: null
}

export const fetchNotification = createAsyncThunk('notification/fetch', async (payload: any, {rejectWithValue}) => {
    try {
        const request = {userId: payload.userId}
        const {data} = await getNotificationMessages(request, payload.token)
        if (!data.successFlag) {
            throw Error(data.errorList)
        }
        return data.response.map((item) => ({
            messageType: item.messageType,
            messageTitle: item.title,
            descriptionHeader: item.header,
            description: item.content,
            carrier: item.carrier,
            displayFrom: item.displayFrom,
            displayTo: item.displayTo,
            messageId: item.messageId
        }))
    } catch (error: any) {
        return rejectWithValue(error.message)
    }
})
export const deactivateNotification = createAsyncThunk(
    'notification/deactivate',
    async (payload: any, {rejectWithValue}) => {
        try {
            const request = {userId: payload.userId, messageId: payload.messageId}
            const {data} = await deactivateNotificationMessage(request)
            if (!data.successFlag) {
                throw Error(data.errorList)
            }
            return data
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        resetNotificationState: (state) => initialState
    },
    extraReducers: function (builder) {
        builder.addCase(fetchNotification.pending, (state, action) => {
            state.isLoading = true
            state.response = []
        })
        builder.addCase(fetchNotification.fulfilled, (state, action) => {
            state.isLoading = false
            state.response = action.payload
            state.error = null
        })
        builder.addCase(fetchNotification.rejected, (state, action: any) => {
            state.isLoading = false
            state.response = []
            state.error = action.payload.error
        })
        builder.addCase(deactivateNotification.pending, (state, action) => {
            state.isLoading = true
            state.deactivateResponse = null
        })
        builder.addCase(deactivateNotification.fulfilled, (state, action) => {
            state.isLoading = false
            state.deactivateResponse = action.payload
            state.error = null
        })
        builder.addCase(deactivateNotification.rejected, (state, action: any) => {
            state.isLoading = false
            state.deactivateResponse = null
            state.error = action.payload.error
        })
    }
})

export const {resetNotificationState} = notificationSlice.actions
export const {reducer: notificationreducer} = notificationSlice
